
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 72 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.167 11.479l26.358 21.023L63.21 11.13","stroke":"#616161","stroke-linejoin":"bevel"}}),_c('path',{attrs:{"d":"M63.21 35.066V11L4 11.345V50.02h30.773","stroke":"#616161"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M32.168 34.902h36.747v24.95H47.843l-5.699 5.7v-5.7h-9.976v-24.95z","stroke":"#616161"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.024 38.793l.194 18.02 37.847-.39.254-18.976-38.295 1.346z","fill":"#FFEDB8"}}),_c('path',{attrs:{"d":"M36.513 52.728h15.143M36.513 47.365h18.74M36.513 41.297h15.143","stroke":"#616161","stroke-linejoin":"bevel"}})])
          )
        }
      }
    